var SearchResultsConstants = {
  PAGE_TYPE_SINGLE: "single",
  PAGE_TYPE_GROUPED: "grouped",
  SORT_TYPE_ASC: "asc",
  SORT_TYPE_DESC: "desc"
};

module.exports = SearchResultsConstants;
